module.exports = __webpack_public_path__ + "img/ygq.ebad419e.png";